import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import allPaths from "../../route/allPaths";

const AuthSuccess = () => {
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      localStorage.setItem("CW_JWT_TOKEN", token);
      history.push(allPaths.HOME_ROUTE);
    } else {
      history.push(allPaths.LOGIN_ROUTE);
    }
  }, []);

  return <div>Logging in...</div>;
};

export default AuthSuccess;